/* eslint-disable */
import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import React from 'react';
import { compose } from 'redux';
import { ORDER_CONFIRM_CUTOFF_DAYS_FROM_TODAY, ORDER_CONFIRM_CUTOFF_TIME, ORDER_STATUS_TO_BE_CONFIRMED } from '../../Constants/Order/Order.constants';
import withEntries from '../../Contexts/Entries/WithEntries.context';
import withServices from '../../Contexts/Services/WithServices.context';
import { ENTRY_PORTAL_CUSTOMER_NAME } from '../../Entries/PortalCustomer/PortalCustomer.entry.constants';
import isBeforeCutOff from '../../Support/DateTime/IsBeforeCutOff/DateTimeIsBeforeCutOff.support';
import envGet from '../../Support/Env/Get/EnvGet.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import OrderCallButton from '../OrderCallButton/OrderCallButton.component';
import OrderConfirmationButton from '../OrderConfirmationButton/OrderConfirmationButton.component';
import OrderActionsPropTypes from './OrderActions.component.props';
import orderActionsStyles from './OrderActions.component.styles';

const FEATURE_TOGGLE_OKTA_SUPPORT = envGet({ key: `REACT_APP_BORAL_FEATURE_TOGGLE_OKTA_SUPPORT` }) === `true`;

/**
 * OrderActionsComponent
 * @export
 * @class OrderActionsComponent
 * @extends {React.Component<OrderActionsComponentComposedProps, OrderActionsComponentState>}
 */
export class OrderActionsComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<OrderActionsComponentProps>}
   * @memberof OrderActionsComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderActions`}
   * @memberof OrderActionsComponent
   */
  static displayName = `OrderActions`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderActionsComponent
   */
  static propTypes = OrderActionsPropTypes;

  /**
   * Data specific to the `<OrderActionsComponent />` instance
   * @type {OrderActionsComponentState}
   * @memberof OrderActionsComponent
   */
  state = {};

  /**
   * Determines whether the Call to Action Confirmation button will be shown
   * @returns {boolean} Whether or not to show user is a Super User and if the order status is 'To Be Confirmed'
   * @memberof NavbarComponent
   */
  shouldRenderConfirmButton = () => {
    if (!FEATURE_TOGGLE_OKTA_SUPPORT) {
      return false;
    }
    const { entry, summary } = this.props;
    const { startTime, status } = summary;
    if (entry.name !== ENTRY_PORTAL_CUSTOMER_NAME) {
      return false;
    }
    if (status !== ORDER_STATUS_TO_BE_CONFIRMED) {
      return false;
    }
    const canConfirm = isBeforeCutOff(startTime, ORDER_CONFIRM_CUTOFF_TIME, ORDER_CONFIRM_CUTOFF_DAYS_FROM_TODAY);
    if (!canConfirm) {
      return false;
    }
    return true;
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderActionsComponent />`
   * @memberof OrderActionsComponent
   */
  render() {
    const { details, summary, width } = this.props;
    if (!summary || !details) {
      return null;
    }
    const { boralTel: callBoral } = details;
    const isSmall = isWidthDown(`xs`, width);
    const isLarge = isWidthUp(`lg`, width);
    const justify = isSmall || isLarge ? `center` : `flex-end`;
    const itemProps = isSmall && { xs: 12 };
    return (
      <Grid container justify={justify} spacing={1}>
        {this.shouldRenderConfirmButton() && (
          <Grid item {...itemProps}>
            <OrderConfirmationButton details={details} summary={summary} />
          </Grid>
        )}
        <Grid item {...itemProps}>
          <OrderCallButton contactNumber={callBoral} />
        </Grid>
      </Grid>
    );
  }
}

/** @type {React.ComponentClass<OrderActionsComponentProps>} */
const OrderActions = compose(
  withEntries,
  withServices,
  withWidth(),
  withStyles(themeCreateInjectableStyles(orderActionsStyles), { withTheme: true }),
)(OrderActionsComponent);

export default OrderActions;
